import {Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-pagina-dinamica',
  templateUrl: './pagina-dinamica.component.html'
})

export class PaginaDinamicaComponent implements OnChanges, OnInit {
  @Output() changed: EventEmitter<any> = new EventEmitter<any>();

  @Input() title;
  @Input() config: any[];

  constructor(private _activatedRoute: ActivatedRoute) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes['title']) {
      this.title = undefined;
    }
  }

  ngOnInit() {
    this._activatedRoute.data.subscribe(data => {
      if (data && !this.config) {
        this.config = data.componentes;
      }
    });
  }
}
